export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ced81b21-fa98-41ab-ad4d-00d86c14d16a';
export const MODAL_CLOSE_SEC = 2.5;
